import { render, staticRenderFns } from "./GeneralMacroPopup.vue?vue&type=template&id=1ca4cd29&scoped=true&"
import script from "./GeneralMacroPopup.vue?vue&type=script&lang=js&"
export * from "./GeneralMacroPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMacroPopup.vue?vue&type=style&index=0&id=1ca4cd29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4cd29",
  null
  
)

export default component.exports